import React from 'react';
import { Checkbox, MousePositionedTooltip } from '@keen.io/ui-core';
import { HeaderCellContent } from '../../header-cell-content';
export var Header = function (_a) {
    var getToggleAllRowsSelectedProps = _a.getToggleAllRowsSelectedProps, toggleAllRowsSelected = _a.toggleAllRowsSelected, editMode = _a.editMode;
    var checked = getToggleAllRowsSelectedProps().checked;
    return (React.createElement(MousePositionedTooltip, { isActive: editMode, tooltipPinPlacement: "bottom-right", renderContent: function () {
            return 'Row selection is not possible during value formatting.';
        } },
        React.createElement(HeaderCellContent, { onClick: function () { return !editMode && toggleAllRowsSelected(); }, textAlignment: "center" },
            React.createElement(MousePositionedTooltip, { isActive: !editMode, tooltipPinPlacement: "bottom-right", renderContent: function () {
                    return checked ? 'Unselect all rows' : 'Select all rows';
                } },
                React.createElement(Checkbox, { id: "select-all-rows", type: "highlight", display: "inline-flex", checked: checked })))));
};
